import {
  useEffect,
  useRef,
  useState,
  Children,
  isValidElement,
  cloneElement,
  memo,
} from "react";
import { Box, useBreakpointValue } from "@chakra-ui/react";

const MapInner = ({
  center = {
    lat: 25.080426196242,
    lng: 121.56746957141,
  },
  zoom = 14,
  onClick,
  onDrag,
  onBoundsChanged,
  onCenterChanged,
  onZoomChanged,
  children,
  mapStyles,
}) => {
  const ref = useRef(null);
  const [map, setMap] = useState(null);

  useEffect(() => {
    if (ref.current && !map) {
      const openZoomControl = window?.innerWidth > 768 ? true : false;
      const googleMap = new window.google.maps.Map(ref.current, {
        center,
        zoom,
        disableDefaultUI: true,
        clickableIcons: false,
        disableDoubleClickZoom: true,
        gestureHandling: "greedy",
        styles: mapStyles,
        zoomControl: openZoomControl,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
      });
      googleMap.addListener("click", onClick);
      googleMap.addListener("drag", onDrag);
      googleMap.addListener("bounds_changed", () => {
        onBoundsChanged(googleMap);
      });
      googleMap.addListener("center_changed", () => {
        onCenterChanged(googleMap);
      });
      googleMap.addListener("zoom_changed", () => {
        onZoomChanged(googleMap);
      });

      setMap(googleMap);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current]);

  useEffect(() => {
    if (map) {
      map.setCenter(center);
    }
  }, [map, center]);

  useEffect(() => {
    if (map) {
      map.setZoom(zoom);
    }
  }, [map, zoom]);

  useEffect(() => {
    let listener;
    if (map) {
      listener = map.addListener("click", onClick);
    }
    return () => {
      listener?.remove();
    };
  }, [map, onClick]);

  useEffect(() => {
    let listener;
    if (map) {
      listener = map.addListener("drag", onDrag);
    }
    return () => {
      listener?.remove();
    };
  }, [map, onDrag]);

  useEffect(() => {
    let listener;
    if (map) {
      listener = map.addListener("bounds_changed", () => {
        onBoundsChanged(map);
      });
    }
    return () => {
      listener?.remove();
    };
  }, [map, onBoundsChanged]);

  useEffect(() => {
    let listener;
    if (map) {
      listener = map.addListener("center_changed", () => {
        onCenterChanged(map);
      });
    }
    return () => {
      listener?.remove();
    };
  }, [map, onCenterChanged]);

  return (
    <>
      <Box ref={ref} id="map" w="100%" h="100%"></Box>
      {Children.map(children, (child) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            key: child.props.data.id,
            map,
          });
        }
      })}
    </>
  );
};

export default memo(MapInner);
